export default function AccessDenied() {
  return (
    <div className="min-h-screen bg-[#f8f9fc] flex flex-col items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full border border-gray-200">
        <h1 className="text-2xl font-bold mb-4 text-[#E21833]">Access Denied</h1>
        <p className="text-gray-700 mb-6">
          You do not have permission to access this application.
          Please contact your administrator if you believe this is an error.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="bg-[#E21833] text-white px-4 py-2 rounded hover:bg-[#c41400] transition-colors duration-200"
        >
          Refresh Page
        </button>
      </div>
    </div>
  );
}